import { call, put, takeLatest } from 'redux-saga/effects'
import {
  editPoolSuccess,
  editPoolFailed,
  EDIT_POOL_START
} from '../../actions/pools'
import { api } from '~/services/api'

/**
 * edit pool api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const editPoolApi = (props) => {
  var uri = `/admin/pools/edit`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doEditPools(action) {
  try {
    const response = yield call(editPoolApi, action?.payload)
    yield put(editPoolSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(editPoolFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch edit pools
 */
export default function* watchEditPool() {
  yield takeLatest(EDIT_POOL_START, doEditPools)
}
